import React from 'react';
import { useParams } from 'react-router-dom';

import PageTitle from '@/components/common/PageTitle/PageTitle';
import useGetContractDetails from '@/hooks/contract/useGetContractDetails.hook';
import ContracHeadersPlaceholder from './components/ContracHeadersPlaceholder';
import ContractLinesContainer from './ContractLines.container';

export default function AddContractLinesContainer() {
  const { contractId }: { contractId: UUID } = useParams();
  const { contract } = useGetContractDetails(contractId);

  return (
    <>
      <div className="mb-20">
        <PageTitle title="Add Contract Lines" />
      </div>

      {contract && (
        <>
          <div className="mb-20">
            <ContracHeadersPlaceholder contract={contract} />
          </div>

          <ContractLinesContainer />
        </>
      )}
    </>
  );
}
